/** ToDo: добавить статусы и сопоставить с цветами. */

const statusColors = (status) => {
  switch (status) {
    case 'approved': return 'green';
    // case '': return 'red';
    // case '': return 'orange';
    // case '': return 'white';
    default: return 'orange';
  }
};

export default statusColors;
